<template>
  <div class="hero-slider">
    <swiper
      ref="mySwiper"
      @slideChangeTransitionStart="slideChangeTransitionStart"
      @slideChangeTransitionEnd="slideChangeTransitionEnd"
      class="swiper"
      :options="swiperOption"
    >
      <swiper-slide class="swiper-item" v-for="(slide, i) in slides" :key="i">
        <HeroSliderItem
          :with-sidebar="true"
          block-name="banner"
          :position="i + 1"
          :slide-alt="slide.slide_alt"
          :slide-img="slide.slide_img"
          :slide-mob-img="slide.slide_mob_img"
          :slide-webp="slide.slide_webp"
          :slide-mob-webp="slide.slide_mob_webp"
          :slide-url="slide.slide_url"
          :slide-id="slide.slide_id"
        />
      </swiper-slide>
    </swiper>
    <div class="hero-slider__navigation">
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="hero-slider__pagination">
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import HeroSliderItem from './HeroSliderItem'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'HeroSliderNew',
  components: {
    HeroSliderItem,
    Swiper,
    SwiperSlide
  },
  computed: {
    ...mapGetters(['isShowedSkeletons']),
    ...mapState({
      slides: state => state.init.config.bannerSlides
    }),
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  data () {
    return {
      swiperOption: {
        preloadImages: false,
        slidesPerView: 1,
        spaceBetween: 7,
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        speed: 1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          '768': {
            spaceBetween: 17
          }
        }
      }
    }
  },
  methods: {
    slideChangeTransitionStart () {
      let $wrapperEl = this.swiper.$wrapperEl
      let params = this.swiper.params
      $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
        .each(function () {
          let idx = this.getAttribute('data-swiper-slide-index')
          this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html()
        })
    },
    slideChangeTransitionEnd () {
      setTimeout(() => {
        this.swiper.slideToLoop(this.swiper.realIndex, 0, false)
      }, 0)
    }
  },
  mounted () {
    const skeleton = document.querySelector('.hero-slider-wrap')
    if (skeleton) {
      skeleton.classList.remove('hero-slider-wrap--loading')
    }
  }
}
</script>

<style scoped lang="sass">

@import "../../styles/swiper/swiper"

.skeleton-desktop
  display: none

  +mmin($tablet--hor)
    display: block

.swiper-slide
  width: 100%

.swiper-button-prev
  left: 15px
  width: 25px
  height: 25px
  margin-top: -12.5px
  +mmax($tablet--hor)
    &:after
      font-size: 8px
  +mmin($tablet--hor)
    left: 30px
    margin-top: -15px
    width: 30px
    height: 30px

.swiper-button-next
  right: 15px
  width: 25px
  height: 25px
  margin-top: -12.5px
  +mmax($tablet--hor)
    &:after
      font-size: 8px
  +mmin($tablet--hor)
    right: 30px
    margin-top: -15px
    width: 30px
    height: 30px

.hero-slider__item
  border-radius: 5px
  overflow: hidden

.skeleton-mobile
  display: block

  +mmin($tablet--hor)
    display: none

.swiper
  position: absolute
  left: 0
  top: 0
  width: 100%
.hero-slider
  position: absolute
  left: 0
  top: 0
  width: 100%
  height: 100%

.hero-slider__navigation
  display: none
  position: absolute
  top: 50%
  left: 0
  width: 100%
  transform: translateY(-50%)
  z-index: 1
  +mmin($tablet--hor)
    display: block

.hero-slider__pagination ::v-deep
  width: 100%
  position: absolute
  bottom: 10px
  z-index: 1
  //+mmax($tablet--hor)
  //  display: none

  +mmin($tablet--hor)
    bottom: 20px

  .swiper-pagination
    position: static

  .swiper-pagination-bullet
    background: $white-text-color
    opacity: .8
    transition: all 0.2s

    &:not(:last-child)
      margin-right: 5px

      +mmin($tablet--hor)
        margin-right: 10px

  .swiper-pagination-bullet-active
    opacity: 1
    background: #ff2f00

</style>
